import {OrderItemReason, IOrderItemReason} from 'app/blocks/model/order-item-reason.model';
import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Resource} from 'app/constants/resource';
import EntityCrudService from 'app/blocks/service/api/entity-service';

@Injectable({
    providedIn: 'root'
})
export class OrderItemReasonService extends EntityCrudService<IOrderItemReason> {
    constructor(http: HttpClient) {
        super(http, Resource.ORDER_ITEM_REASONS, (obj?) => new OrderItemReason(obj));
    }
}
